export const PERIOD_INDEPENDENT_DASHBOARDS = [
  'refine-customer',
  'hr',
  'customer-purchase-behavior',
  'customer-grouping',
  'market-pulse',
  'presentation',
  'changelog',
  'release-notes',
  'product-doc',
] as const;

export type PeriodIndependentDashboard = (typeof PERIOD_INDEPENDENT_DASHBOARDS)[number];

export function isPeriodSelectorDisabled(dashboardId: string): boolean {
  return (PERIOD_INDEPENDENT_DASHBOARDS as readonly string[]).includes(dashboardId);
}

/** داشبوردهای سطح برند که انتخاب شعبه روی داده اثر ندارد */
export const BRANCH_INDEPENDENT_DASHBOARDS = [
  'customer-grouping',
  'brand-overview',
  'branch-comparison',
  'branch-summary',
] as const;

export type BranchIndependentDashboard = (typeof BRANCH_INDEPENDENT_DASHBOARDS)[number];

export function isBranchSelectorDisabled(dashboardId: string): boolean {
  return (BRANCH_INDEPENDENT_DASHBOARDS as readonly string[]).includes(dashboardId);
}

/** داشبوردهایی که بنر «آخرین بروزرسانی داده» نمایش داده نمی‌شود */
export const DATA_FRESHNESS_EXCLUDED_DASHBOARDS = [
  'presentation',
  'changelog',
  'release-notes',
  'product-doc',
  'market-pulse',
] as const;

export function shouldShowDataFreshnessBanner(dashboardId: string): boolean {
  return !(DATA_FRESHNESS_EXCLUDED_DASHBOARDS as readonly string[]).includes(dashboardId);
}
